import '../../../ExpandedCase/ExpandedCase.scss';
import { DetailsCardProps } from '../CaseDetails';
import { CASES_PAGE } from 'config/paths';
import ExpandButton from 'components/ExpandButton/ExpandButton';
import { CaseTitle } from 'components/Cases/CaseTitle';

export const CaseHeaderDetailsCard = ({
  selectedRow,
  navigationState = {},
}: DetailsCardProps & { isFormDisabled: boolean }) => {
  return (
    <div className="case-details-header">
      {selectedRow?.id ? (
        <div className="case-details-header-title">
          <CaseTitle />
          <ExpandButton
            expandedPageUrl={CASES_PAGE(selectedRow.id)}
            navigationState={navigationState}
          />
        </div>
      ) : (
        <div className="cases-page-content-edit">
          <div className="case-header">
            <CaseTitle />
          </div>
        </div>
      )}
    </div>
  );
};

export default CaseHeaderDetailsCard;
